import { defineStore, type Store } from "pinia";
import { getStorageItem, setStorageItem } from "@/libs/local-storage";

const localStorageKey = "localSettings";

function getSystemTheme(): string {
    if (
        globalThis?.matchMedia?.("(prefers-color-scheme: dark)")?.matches
    ) {
        return "njorda-dark";
    }
    return "njorda";
}

export type ConfigState = {
    theme: string;
    aiAutoNavigate: boolean;
    // deprecated
    modules: {
        overview: {
            enabled: boolean;
        };
        overviewAdvanced: {
            enabled: boolean;
        };
        overviewBasic: {
            enabled: boolean;
        };
    };
};

// Defer store creation until plugin and pinia has been loaded, as recommended
//  https://pinia.vuejs.org/core-concepts/outside-component-usage.html#Single-Page-Applications

function makeStore() {
    const configStore = defineStore("config", {
        state: (): ConfigState => {
            const storedConfig = getStorageItem<Partial<ConfigState>>(localStorageKey);
            const config = {
                theme: getSystemTheme(),
                aiAutoNavigate: true,
                modules: {
                    overview: {
                        enabled: true,
                    },
                    overviewAdvanced: {
                        enabled: true,
                    },
                    overviewBasic: {
                        enabled: true,
                    },
                },
            };

            if (storedConfig) {
                return { ...config, ...storedConfig };
            }
            return config as ConfigState;
        },
    })();
    configStore.$subscribe((_mutation, state) => {
        setStorageItem(localStorageKey, state);
    });
    return configStore;
}

let instance: Store<"config", ConfigState, unknown, unknown>;

export function useLocalConfigStore() {
    if (!instance) {
        instance = makeStore();
    }
    return instance;
}
